module.exports = __webpack_public_path__ + "images/hotel_placeholder.cd7155d.png";